import React from 'react';
import { SVGS } from '../../assets';
import './order-summary-card.scss';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';

export interface OrderSummary {
  skuCount: number;
  quantity: number;
  orderAmount: number;
  schemeSaving: number;
  grossAmount: number;
  tax: number;
  orderValue: number;
}

interface OrderSummaryCardProps {
  orderSummary: OrderSummary;
  title?: string;
}

export const OrderSummaryCard: React.FC<OrderSummaryCardProps> = ({
  orderSummary,
  title = 'Order Summary',
}) => {
  const {
    skuCount,
    quantity,
    orderAmount,
    schemeSaving,
    grossAmount,
    tax,
    orderValue,
  } = orderSummary || {};

  return (
    <div className="billing-summary-wrapper">
      <div className="billing-summary">
        {/* Header */}
        <div className="billing-summary-header font-semibold">
          <img src={SVGS.BillIcon} alt="bill summary icon" />
          {title}
        </div>

        <div className="billing-summary-bill">
          {/* Row 1 */}
          <div className="billing-summary-bill-section font-regular">
            <SummaryRow label="Total Items" value={skuCount} />
            <SummaryRow label="Total Quantity" value={quantity} />
          </div>

          {/* Row 2 */}
          <div className="billing-summary-bill-section font-regular">
            <SummaryRow
              label="Order Amount"
              value={getFormattedAmount(orderAmount)}
            />
            <SummaryRow
              label="Scheme Savings"
              value={`-${getFormattedAmount(schemeSaving)}`}
              valueClass="green"
            />
          </div>

          {/* Row 3 */}
          <div className="billing-summary-bill-section font-regular">
            <SummaryRow
              label="Gross Amount"
              value={getFormattedAmount(grossAmount)}
            />
            <SummaryRow label="GST Tax" value={`+${getFormattedAmount(tax)}`} />
          </div>

          {/* Final Total */}
          <div className="billing-summary-bill-section font-semibold">
            <div className="billing-summary-bill-section-content">
              <div className="billing-summary-bill-section-content-total">
                <span className="billing-summary-bill-section-content-total-key font-bold">
                  Estimated Order Value
                </span>
                <span className="billing-summary-bill-section-content-total-subKey font-regular">
                  Incl. all taxes and charges
                </span>
              </div>
              <span className="billing-summary-bill-section-content-totalValue font-bold">
                {getFormattedAmount(orderValue)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SummaryRow = ({
  label,
  value,
  valueClass = '',
}: {
  label: string;
  value: any;
  valueClass?: string;
}) => (
  <div className="billing-summary-bill-section-content">
    <span className="billing-summary-content-text">{label}</span>
    <span className={`billing-summary-content-value ${valueClass}`}>
      {value}
    </span>
  </div>
);
